import { axiosInstance as axios } from 'Api';
import { handlingResponse } from 'Utility/globalMethods';
/* eslint-disable global-require */
if (ISMOCK) {
	require('Mocks/transactions/transactions');
}

export async function transactionList(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'transaction/list',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function transactionFind(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'transaction/find',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function transactionDetail(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'transaction/detail',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function generateTransactionsReportStatus(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'transaction/report/generateStatus',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function transactionDoReversing(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'transaction/refund',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function transactionsWithdrawReverse(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'transaction/withdrawReverse',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
// @generator api:method
